export default __webpack_public_path__ + "static/media/glyph_waves.15010903.webm";